<section class="auth-page">
  <div class="auth-card">
    <img class="auth-logo" src="assets/logo.png" alt="Capital Hub">
    <p class="eyebrow mb-1">Admin Portal</p>
    <h1>Sign in</h1>
    <p class="text-muted-soft">Use your administrator credentials to continue.</p>

    @if (!mustChangePassword) {
    <form class="mt-4" (ngSubmit)="submit()">
      <label class="form-label">Email address</label>
      <input class="form-control" type="email" name="email" [(ngModel)]="email" required>

      <label class="form-label mt-3">Password</label>
      <div class="password-field">
        <input class="form-control" [type]="showPassword ? 'text' : 'password'" name="password" [(ngModel)]="password" required>
        <button class="password-toggle" type="button" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
          <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
        </button>
      </div>

      @if (error) {
        <div class="alert alert-danger py-2 mt-3">{{ error }}</div>
      }

      <button class="btn btn-accent w-100 mt-4" [disabled]="loading || !email || !password">
        {{ loading ? 'Signing in...' : 'Sign in' }}
      </button>
      <a routerLink="/password-reset" class="small-link d-block text-center mt-3">Forgot password?</a>
    </form>
    } @else {
    <form class="mt-4" (ngSubmit)="changePassword()">
      <div class="alert alert-info py-2">
        This account is using a temporary password. Create a new password to continue.
      </div>

      <label class="form-label">New password</label>
      <div class="password-field">
        <input class="form-control" [type]="showNewPassword ? 'text' : 'password'" name="newPassword" [(ngModel)]="newPassword" required>
        <button class="password-toggle" type="button" (click)="showNewPassword = !showNewPassword" [attr.aria-label]="showNewPassword ? 'Hide new password' : 'Show new password'">
          <i class="bi" [class.bi-eye]="!showNewPassword" [class.bi-eye-slash]="showNewPassword"></i>
        </button>
      </div>

      <label class="form-label mt-3">Confirm new password</label>
      <div class="password-field">
        <input class="form-control" [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword" [(ngModel)]="confirmPassword" required>
        <button class="password-toggle" type="button" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="showConfirmPassword ? 'Hide confirmation password' : 'Show confirmation password'">
          <i class="bi" [class.bi-eye]="!showConfirmPassword" [class.bi-eye-slash]="showConfirmPassword"></i>
        </button>
      </div>

      @if (error) {
        <div class="alert alert-danger py-2 mt-3">{{ error }}</div>
      }

      <button class="btn btn-accent w-100 mt-4" [disabled]="loading || !newPassword || !confirmPassword">
        {{ loading ? 'Updating...' : 'Update password' }}
      </button>
    </form>
    }
  </div>
</section>
